import { render } from "./PlanHeader.vue?vue&type=template&id=46a75505&scoped=true"
import script from "./PlanHeader.vue?vue&type=script&lang=js"
export * from "./PlanHeader.vue?vue&type=script&lang=js"

import "./PlanHeader.vue?vue&type=style&index=0&id=46a75505&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a75505"]])

export default __exports__